import React from 'react'
import InputField from '../../../commonComponents/formComponents/inputField'
import { useSelector, useDispatch } from 'react-redux'
import { useMultipleMerchandiseItem } from '../../hooks/useMultipleMerchandiseItem'
import { CustomLoader } from '@commonComponents/formComponents/loader'
import RoutingModal from '@commonComponents/routingModal'
import { Button, Grid } from 'semantic-ui-react'
import { AddBtn } from '@commonComponents/AddBtn'



const CommonAdditionalCode = ({tableName,isFormDisabled,invoiceId,merchandiseId,boxNumber}) => {
    const dataList=useSelector((state)=>state.InvoicesReducer.invoice.merchandise[merchandiseId]?.[`${tableName}`]) || []
    const dispatch = useDispatch()

    const {
        isLoading,
        deleteItem,
        updateItem,
        saveItem,
      } = useMultipleMerchandiseItem({tableName:tableName,invoiceId,merchandiseId})

      const saveData  = async(params) =>{
        const {id,isNewly,...rest} = params
          if(isNewly){
           await saveItem({...rest})
          }
          else{
            saveItem({id,...rest})
          }
      }


      const deleteData = (id) =>{
        const item = dataList?.find(item=>item.id===id)
        if(item?.isNewly){
          dispatch({ type:"DELETE_MERCHANDISE_DOC_BY_ID",
            payload:{id,merchandiseId},
            meta:{tableName:tableName}}) 
        }
        else{
          deleteItem(id)
        }
      }


      const AddItem = () =>{
      dispatch({
        type:"ADD_MERCHANDISE_DOC_BY_ID",
        ids:[{id:Date.now(), isNewly:true ,merchandiseId,invoiceId}],
        meta:{tableName}
        })
      }

    
      const RenderUKAdditionalCode = () =>{
        return (
         <InputField
         isLabel={false}
         id={`${tableName}-${invoiceId}-${merchandiseId}`}
         type='text'
         boxNumber={boxNumber}
         label={tableName === 'ukAdditionalCode'? 'UK Additional Code' :'EU Additional Code'}
         value={dataList?.[dataList.length-1]?.additionalCode}
         className='field-bg borderRight'
         disabled={true}
         onChange={(value) =>updateItem({additionalCode:value})}
         onBlur={(value) =>saveItem({additionalCode:value || " "})}
       />
        )
 }

  return (
    <>
    <Grid.Column
    width={3}
    className="divFormFeild"
  >
    {RenderUKAdditionalCode()}
  </Grid.Column>
  
  <Grid.Column width="1"
   className="divFormFeild"
   style={{borderTop:'1px solid #1765ae'}}
   >
  {isLoading && <CustomLoader />}
            <RoutingModal
              isFormDisabled={isFormDisabled}
              headerName='ADDITIONAL CODE'
              triggerContent={
                dataList?.length<2?
              <AddBtn
              text='ADD' 
              size="mini"
              className='addrepeatBtn'
              />
              :
            
                <span style={{
                    textAlign: 'center',
                    marginTop: '12px',
                    fontWeight: '800',
                    color: 'blue',
                    cursor: 'pointer',
                    display:'block'
                  }}>
                    +{dataList?.length - 1}
                  </span>
            
              }
              valueKey='additionalCode'
              limit={99}
              AddItem={AddItem}
              saveData={saveData}
              updateData={updateItem}
              deleteData={deleteData}
              dataList={dataList}
              dataSource={[]}
              fieldType={'input'}
              countryCode='GB'
            />
      </Grid.Column>
      </>
   
  )
}

export default React.memo(CommonAdditionalCode)